/**
 * @description
 * The 'listitem' role is used to identify an element that is a single item in a list.
 *
 * @specification
 * Adds role='listitem'.
 */
var basicListItemBehavior = function basicListItemBehavior(props) {
  return {
    attributes: {
      root: {
        role: 'listitem'
      }
    }
  };
};

export default basicListItemBehavior;
//# sourceMappingURL=basicListItemBehavior.js.map
